import { useNavigate } from 'react-router-dom';
import { Button, Dropdown, type MenuProps } from 'antd';
import { CheckOutlined, DownOutlined, PlusOutlined, SettingOutlined } from '@ant-design/icons';
import { useAuthStore } from '@presentation/stores/authStore';
import { useSwitchWorkspace, useWorkspaces } from '@presentation/hooks/useWorkspaces';
import { paths } from '@app/routes/paths';

export const WorkspaceSwitcher = () => {
  const navigate = useNavigate();
  const user = useAuthStore((state) => state.user);
  const { data: workspaces } = useWorkspaces();
  const switchWorkspace = useSwitchWorkspace();

  const current =
    workspaces?.find((workspace) => workspace.id === user?.currentWorkspaceId) ?? workspaces?.[0];

  const items: MenuProps['items'] = [
    ...(workspaces?.map((workspace) => ({
      key: workspace.id,
      label: workspace.name,
      icon:
        workspace.id === user?.currentWorkspaceId ? (
          <CheckOutlined />
        ) : (
          <span style={{ width: 14 }} />
        ),
    })) ?? []),
    { type: 'divider' },
    { key: 'manage', label: 'Manage workspaces', icon: <SettingOutlined /> },
    { key: 'new', label: 'New workspace', icon: <PlusOutlined /> },
  ];

  const handleClick: MenuProps['onClick'] = ({ key }) => {
    if (key === 'manage') {
      navigate(paths.workspaces);
      return;
    }
    if (key === 'new') {
      navigate(paths.newWorkspace);
      return;
    }
    if (key !== user?.currentWorkspaceId) {
      switchWorkspace.mutate(key);
    }
  };

  return (
    <Dropdown menu={{ items, onClick: handleClick }} trigger={['click']}>
      <Button
        type="text"
        loading={switchWorkspace.isPending}
        className="min-w-0 max-w-[140px] sm:max-w-[220px] lg:max-w-xs"
      >
        <span className="truncate">{current?.name ?? 'Select workspace'}</span>
        <DownOutlined style={{ fontSize: 10 }} />
      </Button>
    </Dropdown>
  );
};
